import React, { useState } from 'react';
import { Container, TabContent, TabPane } from 'reactstrap';
import NavTab from '../../shared/components/custom/NavTab';
import { withRouter } from 'react-router-dom';

import t, { partial } from '../../util/translation/translation';

import DealsList from './components/DealsList';
import CompaniesList from './components/CompaniesList';
import UsersList from './components/UsersList';
import SummaryList from './components/SummaryList';

const s = partial('shared');

const DealsListPage = () => {
  const [tab, setTab] = useState('1');

  return (
    <Container>
      <NavTab
        activeTab={tab}
        tabs={[s('deals'), s('companies'), s('users'), s('activityLog')]}
        setTab={(activeTab) => setTab(activeTab)}
      />
      <TabContent activeTab={tab}>
        <TabPane tabId="1">
          <SummaryList />
        </TabPane>
        <TabPane tabId="2">
          <CompaniesList />
        </TabPane>
        <TabPane tabId="3">
          <UsersList />
        </TabPane>
        <TabPane tabId="4">
          <DealsList />
        </TabPane>
      </TabContent>
    </Container>
  );
};

export default withRouter(DealsListPage);
